export default "__VITE_ASSET__pKFw9_tm__"